import React from "react";
import PropTypes from "prop-types";
import Link from "@mui/material/Link";

const SFLink = (props) => {
  return (
    <Link
      {...(props.href && { href: props.href })}
      underline={props.underline}
      color={props.color}
      variant={props.variant}
      {...props}
    >
      {props.children}
    </Link>
  );
};

SFLink.defaultProps = {
  color: "primary",
  variant: "blue",
  underline: "always",
};

SFLink.propTypes = {
  color: PropTypes.string,
  variant: PropTypes.string,
  underline: PropTypes.oneOf(["always", "hover", "none"]),
};

export default SFLink;
